export default __webpack_public_path__ + "static/media/IMG_4934.7465f169.png";